import { type FC, type PropsWithChildren } from 'react';

import styles from './GalleryImageWrapper.css';

interface IGalleryImageWrapperProps {
  dataTestId?: string;
}

export const GalleryImageWrapper: FC<PropsWithChildren<IGalleryImageWrapperProps>> = ({ children, dataTestId }) => {
  return (
    <div className={styles['image-wrapper']} data-testid={dataTestId}>
      {children}
    </div>
  );
};
